import { useEffect, useState } from "react";
import { banksApi, unwrapList } from "../api/resources";
import { useBuilderQuery } from "./useBuilderQuery";

export function useBanks() {
  const { query, ready, isBuilder } = useBuilderQuery();
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const builderId = query.builderId;

  useEffect(() => {
    let cancelled = false;
    if (!ready) {
      setBanks([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    banksApi
      .list(builderId ? { builderId } : {})
      .then((res) => {
        if (!cancelled) setBanks(unwrapList(res).items);
      })
      .catch(() => {
        if (!cancelled) setBanks([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [ready, builderId]);

  return { banks, loading, isBuilder };
}
